import { useNavigateBack } from '@exam-management/common/hooks';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { useParams } from '@exam-management/router';

import { QContentCreateHeader } from '../../components';

export default function QContentCreateItemSetSubQuestionHeader() {
  const { qBankStructureInformation } = useQBankStructure();
  const { questionId, structureId } = useParams(
    '/qbank-structures/:structureId/qcontents/item-set/:questionId',
  );

  const { handleBack } = useNavigateBack({
    fallbackPath: '/qbank-structures/:structureId/qcontents/item-set/:questionId',
    matchPatterns: '/qbank-structures/:structureId/qcontents/item-set/:questionId',
    fallbackParams: { structureId, questionId },
  });

  return (
    <QContentCreateHeader
      title='Add New Question to Item Set'
      courseID={qBankStructureInformation.code.toString()}
      qbsName={qBankStructureInformation.name}
      onBack={handleBack}
      navigateBackLabel='Back to Item Set'
    />
  );
}
